module.exports = __webpack_public_path__ + "static/media/note-warning.cc7d68c4.svg";